import React from 'react';
import { CodeOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useFooterPanel } from './FooterPanelContext';

/**
 * Secondary footer: full-width bar fixed at the bottom (under sidebar + content).
 * Developers trigger + expand/collapse chevron only. Content footer stays in content section.
 * Styles: varexe/_footer-panel.scss
 */
function FooterPanelTriggerBar() {
  const { isPanelOpen, openPanel, closePanel } = useFooterPanel();

  return (
    <div className="varexe-footer-panel-trigger-bar">
      <Button
        size="small"
        type="text"
        // className="varexe-footer-panel-trigger-bar__btn"
        onClick={isPanelOpen ? closePanel : openPanel}
        aria-label={isPanelOpen ? 'Close developer panel' : 'Open developer panel'}
      >
        <CodeOutlined />
        Tools
      </Button>
      <Button
        size="small"
        type="text"
        // className="varexe-footer-panel-trigger-bar__chevron"
        onClick={isPanelOpen ? closePanel : openPanel}
        aria-label={isPanelOpen ? 'Close developer panel' : 'Open developer panel'}
      >
        {isPanelOpen ? <DownOutlined /> : <UpOutlined />}
      </Button>
    </div>
  );
}

export default FooterPanelTriggerBar;
